<template>
  <div style="background-color: #474e62;">
        <Row>
          <!-- 适配手机版 -->
          <Col :xs="{ span: 24 }" :lg="{ span: 0 }">
              <!-- <div style="padding:20px 0 20px 0;display:flex;justify-content:center;">
                <img src="../assets/image/logo.png" style="width:220px;height:auto">
              </div> -->
              <!-- <div style="display:flex;justify-content:center;margin:5px 0 30px 0">
                <img src="../assets/image/gzh.jpg" style="width:130px;height:auto">
              </div> -->
              <div style="width:90%;margin-left:5%;margin-top:20px;">
                  <div style="font-size:17px;font-weight:bold;color:#f8f8f9;">友情链接：</div>
                  <!-- 友情链接 -->
                  <Row style="margin-top:20px;">
                    <Col span="12" v-for="(item, index) in linkList" :key="index" style="margin-bottom:25px;">
                      <a :href="item.links_url" target ="_blank" style="color:#CCCDD3;text-decoration:underline;">
                          {{item.links_name}}
              　　　　 </a>
                    </Col>
                  </Row>
                  <!-- 中 -->
                  <div style="display:flex;justify-content: center;color:#fff;margin:0 0 30px 0;">
                    <div style="display:flex;margin-top:10px;margin-right:30px">
                      <img @click="dangzheng" src="../assets/image/img.png" style="cursor: pointer;width:56px;height:67px;margin:0 30px 0 40px">
                      <div style="width:78px;" @click="modal_shengming=true">
                        <img src="../assets/image/wangzhanshengming.png" style="margin-left:15px">
                        <div>网站声明</div>
                      </div>
                      <div style="width:78px;margin:0 20px 0 20px" @click="goDitu">
                        <img src="../assets/image/ditu.png" style="margin-left:15px">
                        <div>网站地图</div>
                      </div>
                      <div @click="modal_link=true" style="width:78px;">
                        <img src="../assets/image/us.png" style="margin-left:15px">
                        <div style="margin-top:3px">联系我们</div>
                      </div>
                    </div>
                  </div>
                  <!-- 地址 -->
                  <div style="color:#fff;display:flex;justify-content: center;">
                    <div>
                      <div>版权所有 © {{obj.banquan}}</div>
                      <div style="margin:18px 0 18px 0">地址: {{obj.address}}</div>
                      <div>总机: 0391-5355322/5355222</div>
                      <div style="margin:18px 0 18px 0">
                        <a :href="obj.icp_url" target="_blank" style="color:#fff;">{{obj.icp}}</a>
                      </div>
                      <div >
                        <a :href="obj.number_url" target="_blank" style="color:#fff;">
                          <img src="../assets/image/gn.png" class="gongan" alt="公安" style="width:20px;height:20px;">
                          豫公网安备 {{obj.number}}号
                        </a>
                      </div>
                      <div style="margin:18px 0 30px 0">
                        <a href="http://hnsjsykj.com/" target="_blank" style="color:#fff;" >技术支持: 金盛元科技</a>
                      </div>
                    </div>
                  </div>
              </div>
              <Modal v-model="modal_shengming" title="网站声明" :mask-closable="false" :closable="false">
                <p slot="footer">
                  <Button type="primary" @click="modal_shengming=false">关闭</Button>
                </p>
                <div>
                  <p style="text-indent:27px;">本网站内容由沁阳市第一中学以及相关单位提供，所涉及到的版权归本网站所属。任何媒体、互联网站和商业机构不得利用本网站发布的内容进行商业性的转载，不得歪曲和篡改本网站所发布的内容。如需转载，必须与本单位直接联系获得合法授权。</p>
                  <p style="text-indent:27px;margin-top:15px;">本网站提供的资料如和相关纸质文本不符，以纸质文本为准。</p>
                  <p style="text-indent:27px;margin:15px 0 15px 0">本网站所使用的图片、文字、字体之类资料，无法鉴别所有版权，如果侵犯，请及时通知我们，本网站将在第一时间及时删除。</p>
                  <p style="text-indent:27px;">凡以任何方式登陆本网站或直接、间接使用本网站资料者，视为自愿接受本网站声明的约束。</p> 
                </div>
              </Modal>
              <Modal v-model="modal_link" title="联系我们" :mask-closable="false" :closable="false">
                <p slot="footer">
                  <Button type="primary" @click="modal_link=false">关闭</Button>
                </p>
                <div>
                  <p style="padding-bottom: 10px;">单位名称：沁阳市第一中学</p>
                  <p style="padding: 10px 0;">单位地址：河南省焦作市沁阳市怀府西路</p>
                  <p style="padding: 10px 0;">电话：0391-5282322  5282520</p>
                  <p style="padding: 10px 0;">邮编：454550</p>
                  <p style="padding: 10px 0;">
                    <div style="display:flex">
                      <div style="line-height:100px">微信公众号：</div>
                      <img src="../assets/image/gzh.jpg" style="width:100px;height:auto;">
                    </div>
                  </p>
                  <p style="padding: 10px 0;">网址：
                    <a href="link" target="_blank">{{link}}</a>
                  </p>
                  <div style="padding: 10px 0;display:flex">
                    <div>地图：</div>
                    <a target="_blank" :href="addess">{{fontNumber(addess,35)}} </a>
                  </div>
                </div>
              </Modal>
          </Col>
          <!-- 电脑端 -->
          <Col :xs="{ span: 0 }" :lg="{ span: 24}" style="color:#848893;font-size:16px">
            <!-- 上 -->
            <div style="display:flex;justify-content: center;margin:20px 0 30px 0">
                友情链接：
                <a :href="item.links_url" v-for="(item, index) in linkList" :key="index" target ="_blank" style="color:#CCCDD3;text-decoration:underline;margin-left:30px;">
                    {{item.links_name}}
        　　　　 </a>
            </div>
            <!-- 中 -->
            <div style="display:flex;justify-content: center;">
              <div style="display:flex;margin-top:20px;margin-right:30px">
                <img @click="dangzheng" src="../assets/image/img.png" style="cursor: pointer;width:56px;height:67px;margin:0 30px 0 40px">
                <div style="width:78px;cursor: pointer;" @click="goShengming">
                  <img src="../assets/image/wangzhanshengming.png" style="margin-left:20px">
                  <div>网站声明</div>
                </div>
                <div style="width:78px;cursor: pointer;margin:0 20px 0 20px" @click="goDitu">
                  <img src="../assets/image/ditu.png" style="margin-left:20px">
                  <div>网站地图</div>
                </div>
                <div @click="goLianxi" style="width:78px;cursor: pointer;">
                  <img src="../assets/image/us.png" style="margin-left:20px">
                  <div style="margin-top:3px">联系我们</div>
                </div>
              </div>
              <div>
                <!-- <img src="../assets/image/ewm1.png" style="width:90px;height:auto"> -->
                <!-- <img src="../assets/image/ewm2.png" style="width:90px;height:auto;"> -->
              </div>
            </div>
            <!-- 下 -->
            <div style="display:flex;justify-content: center;margin:20px 0 0 0;padding-bottom:10px">
              <span>版权所有 © {{obj.banquan}}</span>
              <div class="lineStyle"> | </div>
              <span>地址: {{obj.address}}</span>
              <div class="lineStyle"> | </div>
              <span>总机: 0391-5355322/5355222</span>
              <div class="lineStyle"> | </div>
              <a :href="obj.icp_url" target="_blank" style="color:#848893;">{{obj.icp}}</a>
              <div class="lineStyle"> | </div>
              <a :href="obj.number_url" target="_blank" style="color:#848893;">
                <img src="../assets/image/gn.png" class="gongan" alt="公安" style="width:20px;height:20px;">
                豫公网安备 {{obj.number}}号
              </a>
              <div class="lineStyle"> | </div>
              <a href="http://hnsjsykj.com/" target="_blank" style="color:#848893;" >技术支持: 金盛元科技</a>
            </div>
          </Col>
        </Row>
  </div>
</template>
<script>
import { xxShouYeLinks,xxShouYeOther } from '@/api/index'
export default {
  name: 'Footer',
  data(){
    return{
      linkList:[],
      obj:{},
      modal_shengming:false,//弹窗：网站声明
      modal_link:false,//弹窗：联系我们
      link:'https://www.qyyz.cn',
      addess:'https://map.baidu.com/poi/%E6%B2%81%E9%98%B3%E5%B8%82%E7%AC%AC%E4%B8%80%E4%B8%AD%E5%AD%A6/@12569540.506767401,4153167.4194166274,18.04z?uid=6fddd7fdc56a81023517dc26&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&querytype=detailConInfo&da_src=shareurl',
      organ_id:'',
    }
  },
  methods:{
    // Mark:党政机关链接
    dangzheng(){
      window.open('http://bszs.conac.cn/sitename?method=show&id=119BFF57824C080EE053022819ACCD71', '_blank');
    },
    // Mark:友情链接
    goLink(url)
    {
      window.open(url); 
    },
    // Mark:跳转网站地图
    goDitu(){
      window.open('ditu', '_blank');
    },
    // Mark:跳转网站声明
    goShengming(){
      window.open('shengming', '_blank');
    },
    // Mark:跳转联系我们
    goLianxi(){
      window.open('lianxi', '_blank');
    },
    //MarK:字数限制，超出不显示,num字数限制
    fontNumber (date,num) {
      const length = date.length
      if (length > num) {
        var str = ''
        str = date.substring(0, num) + '...'
        return str
      } else {
        return date
      }
    },
  },
  mounted(){
    this.organ_id=this.GLOBAL.organ_id;
    xxShouYeLinks({organ_id:this.organ_id}).then(res=>{
      this.linkList = res.data.data
    })
    xxShouYeOther({organ_id:this.organ_id}).then(res=>{
      this.obj = res.data.data
    })
  }
}
</script>
<style>
.lineStyle{
  margin:0 5px 0 5px
}
</style>
